import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Plus, Scroll } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
interface AddIntrigueDialogProps {
  onAdd: (intrigue: string) => void;
  initialData?: string;
  onCancel?: () => void;
}
const AddIntrigueDialog: React.FC<AddIntrigueDialogProps> = ({
  onAdd,
  initialData,
  onCancel
}) => {
  const [open, setOpen] = useState(initialData ? true : false);
  const {
    register,
    handleSubmit,
    reset,
    formState: {
      errors
    }
  } = useForm<{
    intrigue: string;
  }>({
    defaultValues: {
      intrigue: initialData || ""
    }
  });
  const onSubmit = (data: {
    intrigue: string;
  }) => {
    onAdd(data.intrigue);
    setOpen(false);
    if (!initialData) {
      reset();
    }
  };
  const handleCancel = () => {
    setOpen(false);
    if (onCancel) {
      onCancel();
    }
  };
  const handleOpenChange = (isOpen: boolean) => {
    setOpen(isOpen);
    if (!isOpen && onCancel) {
      onCancel();
    }
  };
  const renderForm = () => <form onSubmit={handleSubmit(onSubmit)} className="space-y-4" data-sentry-component="renderForm" data-sentry-source-file="AddIntrigueDialog.tsx">
            <div>
                <Label htmlFor="intrigue" className="text-slate-100" data-sentry-element="Label" data-sentry-source-file="AddIntrigueDialog.tsx">
                    Intrigue Description
                </Label>
                <Textarea id="intrigue" {...register("intrigue", {
        required: "Intrigue description is required"
      })} className="bg-slate-900/50 border-slate-700 text-slate-100" placeholder="Describe the intrigue or plot element..." rows={5} data-sentry-element="Textarea" data-sentry-source-file="AddIntrigueDialog.tsx" />
                {errors.intrigue && <p className="text-red-400 text-sm mt-1">
                        {errors.intrigue.message}
                    </p>}
            </div>

            <div className="flex justify-end gap-2">
                <Button type="button" variant="ghost" onClick={handleCancel} className="text-sky-400 hover:bg-sky-400/10" data-sentry-element="Button" data-sentry-source-file="AddIntrigueDialog.tsx">
                    Cancel
                </Button>
                <Button type="submit" className="bg-sky-600 hover:bg-sky-700" data-sentry-element="Button" data-sentry-source-file="AddIntrigueDialog.tsx">
                    <Scroll className="w-4 h-4 mr-2" data-sentry-element="Scroll" data-sentry-source-file="AddIntrigueDialog.tsx" />
                    {initialData ? "Update" : "Add"} Intrigue
                </Button>
            </div>
        </form>;
  return <Dialog open={open} onOpenChange={handleOpenChange} data-sentry-element="Dialog" data-sentry-component="AddIntrigueDialog" data-sentry-source-file="AddIntrigueDialog.tsx">
            {!initialData && <DialogTrigger asChild>
                    <Button variant="ghost" size="sm" className="flex items-center gap-2 text-sky-400 hover:bg-sky-400/10">
                        <Plus className="w-4 h-4" />
                        <span>Add Intrigue</span>
                    </Button>
                </DialogTrigger>}
            <DialogContent className="bg-slate-950/95 border-slate-700 max-w-4xl" data-sentry-element="DialogContent" data-sentry-source-file="AddIntrigueDialog.tsx">
                <DialogHeader data-sentry-element="DialogHeader" data-sentry-source-file="AddIntrigueDialog.tsx">
                    <DialogTitle className="text-slate-100" data-sentry-element="DialogTitle" data-sentry-source-file="AddIntrigueDialog.tsx">
                        {initialData ? "Edit" : "Add"} Intrigue
                    </DialogTitle>
                </DialogHeader>
                {renderForm()}
            </DialogContent>
        </Dialog>;
};
export default AddIntrigueDialog;